import { ICollection } from '@/interfaces/doccen-lib/collection.interface';
import cookieCommons from 'common/cookieCommons';
import { Typography } from 'design-system/components/Typography';
import dynamic from 'next/dynamic';
import { ComponentPropsWithoutRef } from 'react';
import AddDocumentToCollectionButton from './components/AddDocumentToCollectionButton';

const DynamicDocumentDragList = dynamic(
  () =>
    import(
      '@/components/elements/doccen-lib/collection-detail/DocumentDragList'
    ),
  {
    ssr: false,
  }
);

type DocumentListProps = ComponentPropsWithoutRef<'div'> & {
  collection: ICollection;
};

const DocumentList = (props: DocumentListProps) => {
  const { collection } = props;
  const { collectionId } = collection || {};

  const tmsUserId = cookieCommons.getTmsUserId();
  const isOwner = collection?.isOwner;

  return (
    <>
      <div className="mb-4 mt-6 flex items-center justify-between lg:mb-6">
        <Typography variant="display2.5">
          Danh sách nội dung ({collection?.totalItems})
        </Typography>
        {isOwner && (
          <AddDocumentToCollectionButton collectionId={collectionId} />
        )}
      </div>

      <DynamicDocumentDragList
        items={collection?.items || []}
        isOwner={isOwner}
      />
    </>
  );
};

export default DocumentList;
